import { Provider } from 'react-redux';
import { store } from 'app/store';
import { ImageSupportProvider } from 'app/context/ImageSupportContext';
import { Layout } from 'modules/application/containers/Layout';
import { SystemCapabilitiesCheck } from 'modules/application/containers/SystemCapabilitiesCheck';

export default function App() {
  return (
    <SystemCapabilitiesCheck>
      <Provider store={store}>
        <ImageSupportProvider>
          <Layout />
        </ImageSupportProvider>
      </Provider>
    </SystemCapabilitiesCheck>
  );
}
